<template>

<core-modal v-on:close="onClose" :loading="is.validating">

	<template v-slot:head>

		Connect username

	</template>

	<template v-slot:default>

        <template v-if="!is.validating">

            <p>Have you become a Patreon? Thank you for supporting the site!</p>
            
            <p>To get your perks you need to connect your BGG username with your Patreon membership. To do so, click the Proceed button below to login via Patreon to validate your membership automatically.</p>

            <div class="notice">It you are receiving the Speed Boost perk your connection may take a long time to complete while your data is re-indexed. Please be patient.</div>

            <p>If you have any issues or rather manual connection, please get in touch via phil@geekgroup.app or DM on Patreon.</p>

        </template>
		
	</template>

	<template v-slot:foot>

		<core-button theme="blue" :loading="is.loading" v-on:click.native="onConfirmClick">Proceed</core-button>

	</template>

</core-modal>

</template>

<script>

export default {

	data: function() {

		return {

			is: {
				loading: false,
                validating: false
			}

		}

	},

    created: function() {

        if (this.$route.query.state) this.validate()

    },

	methods: {

        onConfirmClick: function() {

            this.is.loading = true

            this.$api.get('session/patreon/connect').then(function(json) {

                window.location.href = json.redirect

            }.bind(this), function() {

                this.is.loading = false
                
            }.bind(this))

        },

        validate: function() {
            
            var query = this.$route.query

            this.$router.replace({
                query: null
            })

            this.is.loading = true
            this.is.validating = true

            this.$api.post('session/patreon/connect', query).then(function() {

                window.location.reload()

            }.bind(this), function() {

                this.is.loading = false
                this.is.validating = false

                this.$notify({
                    message: 'Could not validate your membership. Please contact us.',
                    type: 'error'
                })
                
            }.bind(this))

        },

		onClose: function() {

			this.$emit('close')

		}

	}

}

</script>

<style scoped>

.notice {
	padding: 10px;
	border-radius: 4px;
	color: #fff;
	font-size: 16px;
	line-height: 20px;
	background-color: #4881bb;
	font-weight: 400;
    margin-bottom: 20px;
}

.notice:after {
	content: '';
    display: block;
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 0 16px 16px 16px;
    border-color: transparent transparent #4881bb  transparent;
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    position: absolute;
    left: 17px;
    top: -10px;
}

</style>